"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _InboxAttachment = _interopRequireDefault(require("./InboxAttachment"));

var _ModuleLabel = _interopRequireDefault(require("../Module/ModuleLabel"));

var _getInboxLabel2 = _interopRequireDefault(require("./utils/getInboxLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingRight: theme.spacing(1.5),
    paddingLeft: theme.spacing(8),
    marginBottom: theme.spacing(1.5)
  },
  attachments: {
    marginTop: theme.spacing(1.5)
  },
  title: {
    display: "inline",
    fontFamily: "Akkurat, sans-serif",
    fontSize: '24px',
    lineHeight: '1.25',
    marginBottom: theme.spacing(1.5)
  },
  label: {
    fontSize: "12px",
    display: "inline-block",
    verticalAlign: "top",
    marginTop: '.25em',
    marginLeft: '.5em'
  }
}));

const InboxHeader = (_ref) => {
  let _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Untitled" : _ref$title,
      _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? [] : _ref$messages,
      attachments = _ref.attachments,
      onSelect = _ref.onSelect,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "messages", "attachments", "onSelect"]);

  const classes = useStyles();

  const _getInboxLabel = (0, _getInboxLabel2.default)(props),
        label = _getInboxLabel.label,
        labelColor = _getInboxLabel.labelColor;

  if (attachments) {
    return _react.default.createElement("header", {
      className: classes.root
    }, _react.default.createElement(_Typography.default, {
      component: "h1",
      className: classes.title
    }, title), _react.default.createElement(_ModuleLabel.default, {
      className: classes.label,
      label: label,
      color: labelColor
    }), attachments && _react.default.createElement("div", {
      className: classes.attachments
    }, attachments.map((attachment, index) => {
      return _react.default.createElement(_InboxAttachment.default, _extends({}, attachment, {
        onClick: () => onSelect && onSelect(attachment),
        key: index
      }));
    })));
  }

  const subject = messages && messages.length && messages[0].subject || title;
  return _react.default.createElement("header", {
    className: classes.root
  }, _react.default.createElement(_Typography.default, {
    component: "h1",
    className: classes.title
  }, subject), _react.default.createElement(_ModuleLabel.default, {
    className: classes.label,
    label: label,
    color: labelColor
  }));
};

var _default = InboxHeader;
exports.default = _default;
module.exports = exports.default;